module.exports = __webpack_public_path__ + "static/media/IMG_3493_sm.9db308d6.jpg";